import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const ShopLogo = ({
  className,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) => (
  <WithIconRounded
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    round={round}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 81 80" fill="none">
      <rect xmlns="http://www.w3.org/2000/svg" width="81" height="80" rx="30" fill="url('#a')" />
      <path
        d="M31.333 23.333h18.334A1.667 1.667 0 0 1 51 24l4.5 6v25a1.666 1.666 0 0 1-1.667 1.667H27.167A1.666 1.666 0 0 1 25.5 55V30l4.5-6a1.666 1.666 0 0 1 1.333-.667Zm20 6.667-2.5-3.333H32.167L29.667 30h21.666ZM35.5 36.667h-3.333V40a8.333 8.333 0 1 0 16.666 0v-3.333H45.5V40a5 5 0 0 1-10 0v-3.333Z"
        fill="#fff"
      />
      <defs>
        <linearGradient id="a" x1="-2.596" y1="12.192" x2="85.763" y2="103.76" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5252" />
          <stop offset="1" stopColor="#FFD180" />
        </linearGradient>
      </defs>
    </svg>
  </WithIconRounded>
);

ShopLogo.propTypes = {
  className: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

ShopLogo.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  containerColor: null,
  containerSize: 90,
  onClick: null,
  round: false,
  size: 90,
};

export default ShopLogo;
